import { Directive, EventEmitter, Input, Output } from '@angular/core';

export type SortDirection = 'ASC' | 'DESC' | '';
const rotate: { [key: string]: SortDirection } = { 'ASC': 'DESC', 'DESC': 'ASC', '': 'ASC' };
export const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
export interface SortEvent {
    column: string;
    direction: SortDirection;
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "ASC"',
        '[class.desc]': 'direction === "DESC"',
        '(click)': 'rotate()'
    }
})
export class NgbdSortableHeader {

    @Input() sortable: string;
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
}